import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSwift, faPython, faAppStore, faAws, faApple } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

const Services = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container services-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['S', 'e', 'r', 'v', 'i', 'c', 'e', 's']}
                            idx={15}
                        />
                    </h1>

                    <div className="service-section">
                        <h2>Mobile Development and Lifecycle Management</h2>
                        {/* <p className="price">Starting from $15,00</p> */}
                        <p>
                            We engineer native iOS applications using Swift and Objective-C and Android apps in Kotlin. Our process covers architecture implementation (MVVM, SwiftUI-centric patterns), unit and integration testing with XCTest/ XCUITest, CI/CO pipeline integration for automated builds and checks, and deployment via App Store Connect. Post-launch, we provide maintenance, performance monitoring, and managed feature updates.
                        </p>
                    </div>

                    <div className="service-section">
                        <h2>Machine Learning Model Development & Deployment</h2>
                        {/* <p className="price">Contact for quote</p> */}
                        <p>
                            We design, train, and deploy predictive and generative machine learning models. The technical workflow includes establishing data pipelines (ETL/ELT), selecting model architectures (e.g., Transformers, GANS, CNNs) using Frameworks like Tensorflow or PyTorch, and executing training, validation, and hyperparameter tuning. Deployment methods include cloud-based inference, edge optimization, and MLOps practices for monitoring, data drift detection, and automated model retraining.
                        </p>
                    </div>

                    <div className="service-section">
                        <h2>Custom AI Software & Integration</h2>
                        {/* <p className="price">Contact for quote</p> */}
                        <p>
                            We build high-value, proprietary AI software solutions that drive core business innovation. We develop custom generative AI products, predictive AI tools, intelligent decision systems, and specialized algorithms that create competitive advantage. From concept to scalable SaaS, we engineer the intellectual property that defines your market position.
                        </p>
                    </div>
                </div>

                <div className='stage-cube-cont'>
                    <div className='cubeSpinner'>
                        <div className='face1'>
                            <FontAwesomeIcon icon={faSwift} color="#F06529" />
                        </div>
                        <div className='face2'>
                            <FontAwesomeIcon icon={faAppStore} color="#007AFF" />
                        </div>
                        <div className='face3'>
                            <FontAwesomeIcon icon={faPython} color="#4B8BBE" />
                        </div>
                        <div className='face4'>
                            <FontAwesomeIcon icon={faAws} color="#FF9900" />
                        </div>
                        <div className='face5'>
                            <FontAwesomeIcon icon={faApple} color="#A2AAAD" />
                        </div>
                        {/* <div className='face6'>
                            <FontAwesomeIcon icon={faAndroid} color="#3DDC84" />
                        </div> */}
                    </div>
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default Services
